/**
 * Theme Initialization Script
 * Consolidated from inline scripts in theme.liquid for better caching
 * This file is cacheable by Shopify CDN (max-age=31536000)
 */

// Theme Settings (populated by Liquid in theme.liquid via data attribute)
(function() {
  const themeData = document.getElementById('theme-init-data');
  if (themeData) {
    try {
      const data = JSON.parse(themeData.textContent);
      
      // Theme Settings
      window.themeSettings = data.themeSettings || {};
      
      // Constructor.io
      window.cnstrc = window.cnstrc || {};
      window.cnstrc.testCell = data.constructorTestCell || 'variant';
      if (data.constructorUserId) {
        window.cnstrc.userId = data.constructorUserId;
      }
      
      // UXA tracking
      window._uxa = window._uxa || [];
      window._uxa.push(['setCustomVariable', {
        name: 'constructor_test_cell',
        value: window.cnstrc.testCell,
        scope: 'session'
      }]);
    } catch (e) {
      console.error('Theme init error:', e);
    }
  }
})();

// Collections index redirect (prevent loop)
(function() {
  var path = window.location.pathname.replace(/\/+$/, '');
  var isCollectionsIndex =
    path === '/collections' ||
    /^\/[a-z]{2}(-[a-z]{2})?\/collections$/i.test(path);
  
  if (!isCollectionsIndex) return;
  if (sessionStorage.getItem('redirected_collections_index') === '1') return;
  
  sessionStorage.setItem('redirected_collections_index', '1');
  window.location.replace('/');
})();

// iOS detection
(function() {
  if (/iP(ad|hone|od)/.test(navigator.userAgent)) {
    document.documentElement.classList.add('is-ios');
  }
})();

// Klaviyo identification (deferred)
function initKlaviyo(customerEmail) {
  if (!customerEmail) return;
  
  function identifyKlaviyoUser() {
    if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
      try {
        window.klaviyo.identify({"$email": customerEmail});
      } catch (error) {
        console.warn('Klaviyo identify error:', error);
      }
    } else if (window.klaviyo && Array.isArray(window.klaviyo)) {
      window.klaviyo.push(['identify', {"$email": customerEmail}]);
    }
  }
  
  var klaviyoRetryCount = 0;
  var maxRetries = 15;
  
  function waitForKlaviyo() {
    if (window.klaviyo && (typeof window.klaviyo.identify === 'function' || Array.isArray(window.klaviyo))) {
      identifyKlaviyoUser();
    } else if (klaviyoRetryCount < maxRetries) {
      klaviyoRetryCount++;
      var scheduleCheck = window.requestIdleCallback || function(cb) { setTimeout(cb, 200); };
      scheduleCheck(waitForKlaviyo);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForKlaviyo);
  } else {
    waitForKlaviyo();
  }
}

// Export for use in theme.liquid
window.initKlaviyo = initKlaviyo;
